/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img',
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (
        !document.body.classList.contains('home-template') &&
        !document.body.classList.contains('post-template')
    ) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll(
        '.gh-content > table:not(.gist table)',
    );

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* 💜 Fediverse sidebar: move Mastodon embeds into the aside so the post body stays readable. */
(function () {
    const supportsSidebar =
        document.body.classList.contains('post-template') ||
        document.body.classList.contains('page-template');

    if (!supportsSidebar) {
        return;
    }

    const shell = document.querySelector('.gh-fediverse-shell');
    const sidebar = shell ? shell.querySelector('.gh-sidebar') : null;
    const slot = shell ? shell.querySelector('[data-fediverse-slot]') : null;
    const heading = sidebar
        ? sidebar.querySelector('.gh-sidebar-title')
        : null;
    const content = shell ? shell.querySelector('.gh-content') : null;
    const configuredUrl = shell
        ? (shell.getAttribute('data-fediverse-url') || '').trim()
        : '';

    if (!sidebar || !slot || !shell || !content) {
        return;
    }

    let domain = 'mastodon.laurahargreaves.com';
    const anchorCandidates = Array.from(
        content.querySelectorAll('a[href*="' + domain + '"]'),
    );
    let targetUrl = configuredUrl;
    let sourceElement = null;

    if (!targetUrl && anchorCandidates.length) {
        const finalAnchor = anchorCandidates[anchorCandidates.length - 1];

        if (finalAnchor && finalAnchor.href) {
            targetUrl = finalAnchor.href;
            sourceElement = finalAnchor;
        }
    }

    if (!targetUrl) {
        const paragraphCandidates = Array.from(content.querySelectorAll('p'));

        for (
            let index = paragraphCandidates.length - 1;
            index >= 0;
            index -= 1
        ) {
            const paragraph = paragraphCandidates[index];
            const text = paragraph.textContent || '';

            if (!text.includes(domain)) {
                continue;
            }

            const matches = text.match(
                /https:\/\/mastodon\.laurahargreaves\.com\/[^\s)]+/gi,
            );

            if (matches && matches.length) {
                targetUrl = matches[matches.length - 1];
                sourceElement = paragraph;
                break;
            }
        }
    }

    if (!targetUrl) {
        return;
    }

    let embedUrl;

    try {
        embedUrl = new URL(targetUrl);
    } catch (error) {
        return;
    }

    /* ✨ Explanation: Honour the configured Mastodon host so embeds load from the right server. */
    if (embedUrl.hostname) {
        domain = embedUrl.hostname;
    }

    /* ✨ Explanation: Ghost stopped outputting working Mastodon embeds, so we recreate them from the plain link instead. */
    if (!embedUrl.pathname.endsWith('/embed')) {
        embedUrl.pathname = embedUrl.pathname.replace(/\/$/, '') + '/embed';
    }

    if (!embedUrl.searchParams.has('theme')) {
        embedUrl.searchParams.set('theme', 'dark');
    }

    if (sourceElement) {
        const removalTarget = sourceElement.closest
            ? sourceElement.closest('p, .kg-card, blockquote, div, li, section')
            : null;
        const container =
            removalTarget ||
            (sourceElement instanceof HTMLElement ? sourceElement : null);

        /* ✨ Explanation: Drop the placeholder message so the post body stays clean after we relocate the embed. */
        if (sourceElement instanceof HTMLAnchorElement) {
            sourceElement.remove();

            if (container && !container.textContent.trim()) {
                container.remove();
            }
        } else if (sourceElement instanceof HTMLElement) {
            const text = sourceElement.textContent || '';
            const updated = text.replace(targetUrl, '').trim();

            if (!updated) {
                sourceElement.remove();
            } else {
                sourceElement.textContent = updated;
            }
        }
    }

    if (heading) {
        /* ✨ Explanation: Reinstate the toot-centric heading whenever Mastodon is the source. */
        heading.textContent = '💭 Fediverse Thoughts';
    }

    const embedWrapper = document.createElement('div');
    embedWrapper.className = 'fediverse-embed';

    const iframe = document.createElement('iframe');
    iframe.src = embedUrl.toString();
    iframe.className = 'mastodon-embed';
    iframe.title = 'Fediverse post from Mastodon';
    iframe.setAttribute('style', 'width: 100%; border: 0; overflow: hidden;');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('height', '400');
    iframe.setAttribute('allowfullscreen', 'allowfullscreen');

    embedWrapper.appendChild(iframe);

    const script = document.createElement('script');
    script.src = 'https://' + domain + '/embed.js';
    script.async = true;

    /* ✨ Explanation: Load Mastodon's helper to resize the iframe dynamically just like the official embed. */
    embedWrapper.appendChild(script);
    slot.appendChild(embedWrapper);

    sidebar.hidden = false;
    shell.classList.add('has-sidebar');
})();

/* 💜 Reading sidebar: lift BookWyrm list embeds into the aside on posts and pages. */
(function () {
    const supportsSidebar =
        document.body.classList.contains('post-template') ||
        document.body.classList.contains('page-template');

    if (!supportsSidebar) {
        return;
    }

    const shell = document.querySelector('.gh-fediverse-shell');
    const sidebar = shell ? shell.querySelector('.gh-sidebar') : null;
    const slot = shell ? shell.querySelector('[data-fediverse-slot]') : null;
    const content = shell ? shell.querySelector('.gh-content') : null;
    const heading = sidebar
        ? sidebar.querySelector('.gh-sidebar-title')
        : null;

    if (!sidebar || !slot || !shell || !content) {
        return;
    }

    const domain = 'books.laurahargreaves.com';
    let embedUrl = '';
    let sourceElement = null;

    const iframeCandidate = content.querySelector(
        'iframe[src*="' + domain + '/list/"]',
    );

    if (iframeCandidate && iframeCandidate.src) {
        embedUrl = iframeCandidate.src;
        sourceElement = iframeCandidate;
    }

    if (!embedUrl) {
        const anchorCandidate = content.querySelector(
            'a[href*="' + domain + '/list/"]',
        );

        if (anchorCandidate && anchorCandidate.href) {
            embedUrl = anchorCandidate.href;
            sourceElement = anchorCandidate;
        }
    }

    if (!embedUrl) {
        const paragraphCandidates = Array.from(content.querySelectorAll('p'));

        for (let index = paragraphCandidates.length - 1; index >= 0; index -= 1) {
            const paragraph = paragraphCandidates[index];
            const text = paragraph.textContent || '';

            if (!text.includes(domain)) {
                continue;
            }

            const matches = text.match(
                /https:\/\/books\.laurahargreaves\.com\/[^\s)]+/gi,
            );

            if (matches && matches.length) {
                embedUrl = matches[matches.length - 1];
                sourceElement = paragraph;
                break;
            }
        }
    }

    if (!embedUrl) {
        return;
    }

    let url;

    try {
        url = new URL(embedUrl);
    } catch (error) {
        return;
    }

    if (!url.pathname.includes('/embed/')) {
        url.pathname = url.pathname.replace(/\/$/, '') + '/embed/';
    }

    if (heading) {
        /* ✨ Explanation: Swap the label so BookWyrm embeds read as a reading list instead of fediverse notes. */
        heading.textContent = '📚️ Reading List';
    }

    if (slot) {
        /* ✨ Explanation: Clear any Mastodon cards before lifting the BookWyrm embed into the sidebar. */
        while (slot.firstChild) {
            slot.removeChild(slot.firstChild);
        }
    }

    if (sourceElement) {
        const removalTarget = sourceElement.closest
            ? sourceElement.closest('p, .kg-card, blockquote, div, li, section')
            : null;
        const container =
            removalTarget ||
            (sourceElement instanceof HTMLElement ? sourceElement : null);

        /* ✨ Explanation: Trim the placeholder BookWyrm link so the sidebar owns the embed. */
        if (sourceElement instanceof HTMLAnchorElement) {
            sourceElement.remove();

            if (container && !container.textContent.trim()) {
                container.remove();
            }
        } else if (sourceElement instanceof HTMLElement) {
            const text = sourceElement.textContent || '';
            const updated = text.replace(embedUrl, '').trim();

            if (!updated) {
                sourceElement.remove();
            } else {
                sourceElement.textContent = updated;
            }
        }
    }

    const embedWrapper = document.createElement('div');
    embedWrapper.className = 'fediverse-embed fediverse-embed--books';

    const iframe = document.createElement('iframe');
    iframe.src = url.toString();
    iframe.className = 'bookwyrm-embed';
    iframe.title = 'BookWyrm reading list';
    iframe.setAttribute('style', 'width: 100%; border: 0; overflow: hidden;');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('height', '520');
    iframe.setAttribute('allowfullscreen', 'allowfullscreen');

    embedWrapper.appendChild(iframe);

    slot.appendChild(embedWrapper);

    sidebar.hidden = false;
    shell.classList.add('has-sidebar');
})();

/* 💜 Publication recommendations: mirror the Portal markup and prioritise the most detailed picks. */
(function () {
    const sections = Array.from(
        document.querySelectorAll('.gh-recommendations'),
    );
    if (!sections.length) {
        return;
    }

    sections.forEach(function (recommendationsSection) {
        const list = recommendationsSection.querySelector('.recommendations');
        if (!list) {
            return;
        }

        const entries = Array.from(list.querySelectorAll('.recommendation'));
        if (!entries.length) {
            return;
        }

        const scoredEntries = entries.map(function (entry) {
            const description = entry.querySelector(
                '.recommendation-description',
            );

            if (
                description &&
                !description.closest(
                    '.gh-portal-recommendation-description-container',
                )
            ) {
                const wrapper = document.createElement('div');
                wrapper.className =
                    'gh-portal-recommendation-description-container';

                /* ✨ Explanation: Ghost renders descriptions without the Portal wrapper, so we recreate it here for consistent styling. */
                description.parentNode.insertBefore(wrapper, description);
                wrapper.appendChild(description);
            }

            const text = description ? description.textContent.trim() : '';
            const score = text.length;

            return {
                entry,
                score,
            };
        });

        scoredEntries
            .sort(function (a, b) {
                /* ✨ Explanation: Longer blurbs float to the top so rich descriptions appear first. */
                return b.score - a.score;
            })
            .forEach(function (item) {
                list.appendChild(item.entry);
            });
    });
})();
